import React from 'react';
import { Navbar } from '../../components';
import { TypeHeader } from '../../containers';

const Type = () => {
  return (
    <div>
        <div className="gradient__bg">
          <Navbar />
          <TypeHeader />
        </div>
    </div>
  )
}

export default Type